import { render } from "./CardSpec.vue?vue&type=template&id=42e9b214"
import script from "./CardSpec.vue?vue&type=script&lang=js"
export * from "./CardSpec.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/CardSpec.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42e9b214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42e9b214', __exports__)) {
    api.reload('42e9b214', __exports__)
  }
  
  module.hot.accept("./CardSpec.vue?vue&type=template&id=42e9b214", () => {
    api.rerender('42e9b214', render)
  })

}


export default __exports__